<script>
import {h} from 'vue';
import ArticleWho from '@/components/article/ArticleWho.vue';
import ArticleAbout from '@/components/article/ArticleAbout.vue';
import ArticleWhat from '@/components/article/ArticleWhat.vue';
import ArticleExpertise from '@/components/article/ArticleExpertise.vue';
import ArticleWhy from '@/components/article/ArticleWhy.vue';
import ArticleContact from '@/components/article/ArticleContact.vue';
import ArticleTerms from '@/components/article/ArticleTerms.vue';

export default {
    // https://stackoverflow.com/questions/70957780/how-i-can-render-a-component-from-a-string-with-vue-3
    props: {
        html: {
            type: String,
            default: '',
        },
    },
    render() {
        const r = {
            components: {
                ArticleWho,
                ArticleAbout,
                ArticleWhat,
                ArticleExpertise,
                ArticleWhy,
                ArticleContact,
                ArticleTerms,
            },
            template: `
                <div class="content-compiled">${this.html || ''}</div>`,
            /**
            methods: {
                hello () {
                    // method "hello" is also available here
                },
            },
            **/
        };
        return h(r);
    },
};
</script>
